/**
 * Element Plus `ElDatePicker`（type=datetimerange）左侧快捷选项。
 * 与订单充值审核等页的时间段筛选逻辑对齐。
 *
 * 时区口径：用「浏览器本地时区」算日历边界，跟手动点选日期时的 dayBoundaryDefaultTime
 * （AdminDateTimeRange.vue 里的本地 00:00:00 / 23:59:59）保持一致 ——
 * 这样点「今天」显示的就是本地 00:00:00 ~ 23:59:59，而不是 UTC+7 边界被本地时区
 * 换算后偏移 1 小时（旧实现用 UTC+7 的 nowTz()，在 UTC+8 浏览器下「今天」会显示成
 * 01:00:00 ~ 次日 00:59:59）。
 *
 * 后端按「墙上时钟字符串」过滤（value-format 输出的本地时钟串），前端显示什么就传什么，
 * 口径自洽；不需要再按 UTC+7 偏移。
 */
import dayjs from 'dayjs'

export type AdminDateTimeRangeShortcutItem = {
  text: string
  value: () => [Date, Date]
}

export const adminDateTimeRangeShortcuts: AdminDateTimeRangeShortcutItem[] = [
  {
    text: '今天',
    value: () => {
      return [dayjs().startOf('day').toDate(), dayjs().endOf('day').toDate()]
    }
  },
  {
    text: '昨天',
    value: () => {
      const yesterday = dayjs().subtract(1, 'day')
      return [yesterday.startOf('day').toDate(), yesterday.endOf('day').toDate()]
    }
  },
  {
    text: '最近7天',
    value: () => {
      return [dayjs().subtract(6, 'day').startOf('day').toDate(), dayjs().toDate()]
    }
  },
  {
    text: '最近30天',
    value: () => {
      return [dayjs().subtract(29, 'day').startOf('day').toDate(), dayjs().toDate()]
    }
  },
  {
    text: '本月',
    value: () => {
      return [dayjs().startOf('month').toDate(), dayjs().endOf('month').toDate()]
    }
  }
]
